import GridCard from "@/components/census/GridCard";
import { patientNamespace } from "@/store/modules/patient";
import { CensusData, Patient } from "@/store/modules/patient/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import GridCardIcu from "./census/GridCardIcu";
import GridCardOb from "./census/GridCardOb";
import GridCardPacu from "./census/GridCardPacu";
import { AcuityLevel, acuityLevels } from "./shared/util";

@Component({
  components: { GridCard, GridCardOb, GridCardIcu, GridCardPacu }
})
export default class CensusGridAcuity extends Vue {
  @Getter("config", patientNamespace)
  config!: any;

  @Prop(Array)
  patients!: Array<Patient>;

  @Prop(String)
  area!: string;

  getColor(caseStateIndex: number) {
    const caseStates = this.$store.getters["patient/caseState"];
    if (caseStates && caseStates[caseStateIndex]) {
      return caseStates[caseStateIndex].color;
    }
    return null;
  }

  get census() {
    return this.patients
      .filter(this.config.census.grid.filterFunction)
      .map((p: Patient) => p.census);
  }

  get censusGroupedByAcuity() {
    const censusMap: Array<Array<CensusData>> = [[], [], [], [], []];
    this.census.forEach(c => {
      censusMap[c.acuityLevel].push(c);
      // For testing without setting levels
      // const mod = parseInt(c.room, 10) % 5;
      // censusMap[mod].push(c);
    });
    return censusMap;
  }

  acuityLevels: Array<AcuityLevel> = [];

  mounted() {
    this.acuityLevels = [
      acuityLevels[3], // Highest Risk
      acuityLevels[2], // Watcher
      acuityLevels[0], // Not Set
      acuityLevels[1], // Stable
      acuityLevels[4] // Discharge
    ];
  }
}
